export const FETCH_SHOWS_REQUEST = 'FETCH_SHOWS_REQUEST';
export const FETCH_SHOWS_SUCCESS = 'FETCH_SHOWS_SUCCESS';
export const FETCH_SHOWS_FAILURE = 'FETCH_SHOWS_FAILURE';
export const FETCH_SHOW_SUCCESS = 'FETCH_SHOW_SUCCESS';
